<app-layout [isProducerArea]="true">
  <app-page-header
    title="Criar evento"
    titleIcon="pi pi-plus"
    subtitle="
      Preencha as etapas para configurar seu evento e garantir uma experiência incrível para os participantes.
    "
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Área do produtor', link: '/producer-area', icon: 'pi pi-chart-bar' },
      {
        label: 'Criar evento',
        icon: 'pi pi-plus',
      },
    ]" />
  <div class="p-4">
    <app-event-form />
  </div>
</app-layout>
